// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M16 17l-4 4m0 0l-4-4m4 4V3\"/> </svg> ";
// Exports
module.exports = code;